<template>
  <div class="asdfawsef">
    <el-row class="wenzi"> 财务信息 </el-row>
    <el-row :gutter="40">
      <el-col :span="8">
        <el-tabs v-model="activeName" stretch>
          <el-tab-pane name="consumptionRecords" label="消费记录">
          </el-tab-pane>
          <el-tab-pane name="first" label="可开票记录"> </el-tab-pane>
          <el-tab-pane name="second" label="开票记录"> </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="8" class="form-aut-asdf">
        未开票金额: {{ totnum }}
      </el-col>
      <el-col :span="5">
        <el-button type="primary" @click="onSubmitUpdate">汇总开票</el-button>
      </el-col>
    </el-row>
    <el-row v-show="activeName == 'consumptionRecords'">
      <el-table :data="torderListRecords" border class="table-dci">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="商品订单号" prop="outTradeNo">
        </el-table-column>
        <el-table-column label="支付订单号" prop="tradeNo"> </el-table-column>
        <el-table-column label="支付时间" prop="gmtPayment"> </el-table-column>
        <el-table-column label="提交实际" prop="subject"> </el-table-column>
        <el-table-column label="产品数量" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.dciWorks.length }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业务详情">
          <template slot-scope="scope">
            <div v-for="item in scope.row.dciWorks" :key="item.id">
              流水号： {{ item.dciWorkId }}<br />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" prop="totalAmount" width="90">
        </el-table-column>
        <el-table-column label="支付方式" width="90">
          <template slot-scope="scope">
            <span>支付宝</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.dciWorks && scope.row.dciWorks[0]">
              {{ getRefundStatusLabel(scope.row.dciWorks[0].refundStatus) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="workFeedInfoClick(scope.row)"
              >立刻开票
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-row class="table-dci pagination">
        <el-pagination
          @size-change="handleSizeChange3"
          @current-change="handleCurrentChange3"
          :current-page="currentPageRecords"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="pageSizeRecords"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
        >
        </el-pagination>
      </el-row>
    </el-row>
    <el-row v-show="activeName == 'first'">
      <el-table :data="torderList" border class="table-dci">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="商品订单号" prop="outTradeNo">
        </el-table-column>
        <el-table-column label="支付订单号" prop="tradeNo"> </el-table-column>
        <el-table-column label="支付时间" prop="gmtPayment"> </el-table-column>
        <el-table-column label="提交实际" prop="subject"> </el-table-column>
        <el-table-column label="产品数量" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.dciWorks.length }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业务详情">
          <template slot-scope="scope">
            <div v-for="item in scope.row.dciWorks" :key="item.id">
              流水号： {{ item.dciWorkId }}<br />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" prop="totalAmount" width="90">
        </el-table-column>
        <el-table-column label="支付方式" width="90">
          <template slot-scope="scope">
            <span>支付宝</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="workFeedInfoClick(scope.row)"
              >立刻开票
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-row class="table-dci pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
    <el-row v-show="activeName == 'second'">
      <el-table :data="getlist" border class="table-dci">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="申请时间" prop="applyTime"></el-table-column>
        <el-table-column label="开票金额" prop="amount"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.no ? '已开票' : '未开票' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开票时间" prop="uploadTime"></el-table-column>
        <el-table-column label="发票号" prop="no"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="workFeedInfoClick(scope.row)"
              :disabled="scope.row.url ? false : true"
              >{{ scope.row.url ? '下载' : '无资源' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="table-dci pagination">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="currentPage2"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total2"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import {
  invoiceList,
  orderList,
  undoneAmount,
  invoiceApply
} from '@/api/user.js'
export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      activeName: 'first',
      getlist: [],
      torderList: [],
      torderListRecords: [],
      totalRecords: 0,
      pageSizeRecords: 10,
      currentPageRecords: 1,
      totnum: 0
    }
  },
  computed: {},
  created () {
    this.getList()
    this.getOrderList()
    this.getRecordList()
    this.undoneAmountInfo()
  },
  watch: {},
  mounted () {},
  methods: {
    /** 获取退款状态标签 */
    getRefundStatusLabel (status) {
      if (status === 'REFUNDED') return '已退款'
      if (status === 'REFUNDING') return '退款中'
      return '-'
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getOrderList()
    },
    handleSizeChange2 (val) {
      this.pageSize2 = val
      this.getList()
    },
    handleSizeChange3 (val) {
      this.pageSizeRecords = val
      this.getRecordList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    },
    handleCurrentChange2 (val) {
      this.currentPage2 = val
      this.getList()
    },
    handleCurrentChange3 (val) {
      this.currentPageRecords = val
      this.getRecordList()
    },
    workFeedInfoClick (row) {
      const parts = row.url.split('/')
      this.$download.name(row.url, parts[1] + '.' + parts[0])
    },
    onSubmitUpdate () {
      console.log('submit!', this.$store.state.realInformation)

      if (
        !this.$store.state.realInformation.invoiceTitle &&
        !this.$store.state.realInformation.invoiceCertNo
      ) {
        this.$message.error('发票信息需要保存后再申请开票')
        return
      }

      invoiceApply().then(res => {
        if (res.code === 200) {
          this.$message.success('开票成功')
          this.getList()
          this.getOrderList()
          this.getRecordList()
          this.undoneAmountInfo()
        }
      })
    },
    undoneAmountInfo () {
      undoneAmount({
        params: { bizType: 'invoice' }
      }).then(res => {
        this.totnum = res.data || 0
      })
    },
    async getList () {
      const res = await invoiceList(
        {
          params: {
            status: ''
          }
        },
        {
          pageNum: this.currentPage2,
          pageSize: this.pageSize2,
          tableName: undefined,
          tableComment: undefined,
          isAsc: 'desc',
          orderByColumn: 'applyTime'
        }
      )
      this.getlist = res.rows
      this.total2 = res.total

      console.log(res, 'getList')
    },
    async getOrderList () {
      const res = await orderList(
        {
          params: {
            bizType: 'invoice'
          }
        },
        {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          tableName: undefined,
          tableComment: undefined,
          isAsc: 'desc',
          orderByColumn: 'createTime'
        }
      )
      console.log(res, 'getOrderList')
      this.torderList = res.rows
      this.total = res.total
    },
    async getRecordList () {
      const res = await orderList(
        {
          params: {
            bizType: ''
          },
          tradeStatus:"PAIED"
        },
        {
          pageNum: this.currentPageRecords,
          pageSize: this.pageSizeRecords,
          tableName: undefined,
          tableComment: undefined,
          isAsc: 'desc',
          orderByColumn: 'createTime'
        }
      )
      console.log(res, 'getRecordList')
      this.torderListRecords = res.rows
      this.totalRecords = res.total
    }
  }
}
</script>
<style lang="scss" scoped>
.asdfawsef {
  padding-left: 80px;
}
.form-aut-asdf {
  visibility: inherit;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
  line-height: 40px;
  text-align: end;
}
.wenzi {
  height: 80px;
  text-align: center;
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}
.form-aut {
  width: 500px;
}
.pagination {
  text-align: end;
  margin-top: 20px;
}
</style>
